import { Star, ShoppingCart, Share2, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export const ProductTitlePreview = ({ settings }: any) => (
    <h1 style={{
        fontSize: `${settings.fontSize || 24}px`,
        fontWeight: settings.fontWeight || "bold",
        textAlign: settings.textAlign || "left",
        color: settings.color || "inherit"
    }}>
        {settings.text || "Product Title"}
    </h1>
);

export const ProductPricePreview = ({ settings }: any) => (
    <div className="flex items-center gap-2" style={{ justifyContent: settings.textAlign === "center" ? "center" : "flex-start" }}>
        <span style={{
            fontSize: `${settings.fontSize || 20}px`,
            fontWeight: settings.fontWeight || "600",
            color: settings.color || "#000"
        }}>
            {settings.currency || "$"}{settings.price || "49.99"}
        </span>
        {settings.comparePrice && (
            <span className="text-gray-400 line-through text-sm">
                {settings.currency || "$"}{settings.comparePrice}
            </span>
        )}
    </div>
);

export const ProductImagePreview = ({ settings }: any) => (
    <div className="w-full aspect-square bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
        {settings.imageUrl ? (
            <img src={settings.imageUrl} alt="Product" className="w-full h-full object-cover" />
        ) : (
            <div className="text-gray-400 flex flex-col items-center">
                <span className="text-4xl">🖼️</span>
                <span className="text-sm mt-2">Product Image</span>
            </div>
        )}
    </div>
);

export const ProductRatingPreview = ({ settings }: any) => (
    <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
            <Star
                key={i}
                className={`w-4 h-4 ${i < (settings.rating || 5) ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`}
            />
        ))}
        <span className="text-sm text-gray-500 ml-1">({settings.reviewsCount || 120} reviews)</span>
    </div>
);

export const AddToCartPreview = ({ settings }: any) => (
    <Button
        className="w-full gap-2"
        style={{
            backgroundColor: settings.backgroundColor || "#000",
            color: settings.color || "#fff"
        }}
    >
        <ShoppingCart className="w-4 h-4" />
        {settings.text || "Add to Cart"}
    </Button>
);

export const ProductDescriptionPreview = ({ settings }: any) => (
    <p className="text-gray-600 leading-relaxed" style={{ fontSize: `${settings.fontSize || 16}px` }}>
        {settings.text || "This is a premium product description. It highlights the key features and benefits of the product in a compelling way."}
    </p>
);

export const ProductGalleryPreview = ({ settings }: any) => (
    <div className="grid grid-cols-4 gap-2">
        {[1, 2, 3, 4].map((i) => (
            <div key={i} className="aspect-square bg-gray-100 rounded-md flex items-center justify-center">
                <span className="text-xs text-gray-400">Img {i}</span>
            </div>
        ))}
    </div>
);

export const ProductVariantsPreview = ({ settings }: any) => (
    <div className="space-y-3">
        {(settings.variants || [{ name: "Color", options: ["Red", "Blue"] }]).map((variant: any, idx: number) => (
            <div key={idx}>
                <label className="text-sm font-medium mb-1.5 block">{variant.name}</label>
                <div className="flex flex-wrap gap-2">
                    {variant.options.map((opt: string, i: number) => (
                        <Badge
                            key={i}
                            variant={i === 0 ? "default" : "outline"}
                            className="cursor-pointer px-3 py-1"
                        >
                            {opt}
                        </Badge>
                    ))}
                </div>
            </div>
        ))}
    </div>
);
